(function() {
  'use strict';

  function getInventoryCount(variantId, productData) {
    if (!productData || !productData.variants) return null;
    var variant = productData.variants.find(function(v) { return String(v.id) === String(variantId); });
    if (!variant || !variant.inventory_management) return null;
    return variant.inventory_quantity;
  }

  function updateStockDisplay(qty) {
    var stockEl = document.querySelector('.instock');
    if (!stockEl) return;
    var inner = stockEl.innerHTML;
    // Strip any count we previously injected
    inner = inner.replace(/\s*—\s*<strong>\d+<\/strong>\s*in stock/gi, '');
    inner = inner.replace(/\s*&mdash;\s*<strong>\d+<\/strong>\s*in stock/gi, '');
    if (qty !== null && qty > 0) {
      inner = inner.trim() + ' — <strong>' + qty + '</strong> in stock';
    }
    stockEl.innerHTML = inner;
  }

  function init() {
    if (window.location.pathname.indexOf('/products/') === -1) return;
    var handle = window.location.pathname.split('/products/')[1];
    if (!handle) return;
    handle = handle.split('?')[0].split('#')[0];

    var productData = null;

    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        productData = data;
        var urlParams = new URLSearchParams(window.location.search);
        var variantId = urlParams.get('variant');
        if (!variantId && data.variants && data.variants.length > 0) {
          variantId = data.variants[0].id;
        }
        updateStockDisplay(getInventoryCount(variantId, productData));

        document.addEventListener('change', function(e) {
          if (!e.target) return;
          if (e.target.name === 'id' || (e.target.closest && e.target.closest('.main-product-section'))) {
            var newId = e.target.value;
            if (!newId) return;
            updateStockDisplay(getInventoryCount(newId, productData));
          }
        });

        window.addEventListener('popstate', function() {
          var params = new URLSearchParams(window.location.search);
          updateStockDisplay(getInventoryCount(params.get('variant'), productData));
        });

        // Shopify variant change custom event
        document.addEventListener('variant:change', function(e) {
          if (e.detail && e.detail.variant) {
            updateStockDisplay(getInventoryCount(e.detail.variant.id, productData));
          }
        });
      })
      .catch(function() {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
